module.exports = __webpack_public_path__ + "Icono_Warning_126px.png";